import { store } from "../redux/store/configureStore";

export const dispatchStore = data => store.dispatch(data)
